window.addEventListener('load', () => {
    document.querySelectorAll('[data-submit-label]').forEach((element) => {
        const submitLabel = element.getAttribute('data-submit-label');

        element.querySelectorAll('button[type="submit"]').forEach((button) => {
            button.innerText = submitLabel;
        });
    });
});